<template>
  <li class="office-item" :class="item.size">
    <template v-if="item.link">
      <a :href="item.link | mailTo">
        <div class="office-icon">
          <font-awesome-icon icon="paper-plane"></font-awesome-icon>
        </div>

        <div class="office-content">
          <p>{{ item.link }}</p>
        </div>
      </a>
    </template>

    <template v-else>
      <div class="office-icon">
        <font-awesome-icon :icon="[item.iconType, item.icon]"></font-awesome-icon>
      </div>

      <div class="office-content">
        <p>
          {{ item.textUp }}
          <br />
          {{ item.textBottom }}
        </p>
      </div>
    </template>
  </li>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'ItemOffice',
  components: {
    FontAwesomeIcon,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  filters: {
    mailTo(mail) {
      return `mailto:${mail}`;
    },
  },
};
</script>

<style lang="scss" scoped>
li {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 10px;
  background-color: transparent;
  text-align: center;

  &.right {
    div.office-icon {
      order: 2;
    }

    div.office-content {
      order: 1;
      margin: auto 5px auto auto;
    }
  }

  a {
    width: 100%;
    display: flex;
    text-decoration: none;
    p {
      padding: 9px 0;
    }
  }

  div.office-icon {
    position: relative;
    width: 25%;
    text-align: center;
    background-color: #76665b;

    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 2em;
      color: #fff;
    }
  }

  div.office-content {
    width: calc(75% - 5px);
    margin: auto auto auto 5px;
    background-color: #76665b;
    color: #fff;

    p {
      font-family: Georgia, "Times New Roman", Times, serif;
      font-size: 18px;
      line-height: 1em;

      a {
        text-decoration: none;
        color: #666;
      }
    }
  }
}
</style>
